import { ExamIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Word = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ExamIcon size={Sizes[size]} {...rest} color={fill} />;
};

Word.displayName = 'Word';
